import { render } from "./BandLogo.vue?vue&type=template&id=e1dbebe8&scoped=true"
import script from "./BandLogo.vue?vue&type=script&lang=js"
export * from "./BandLogo.vue?vue&type=script&lang=js"

import "./BandLogo.vue?vue&type=style&index=0&id=e1dbebe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1dbebe8"]])

export default __exports__